// extracted by mini-css-extract-plugin
export default {"autoActionScreen":"Join_autoActionScreen__xWPW+","gcLogo":"Join_gcLogo__cSS7g","roomCode":"Join_roomCode__AN1Mz","cancelButton":"Join_cancelButton__y7nY9"};